const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/locations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { LOCATION_SORT_KEYS } from '@/features/location/model/location-columns';
import { createSearchValidator } from '@/lib/search-validators';
type LocationFilters = {
  countryCodes?: string;
};
export const Route = createFileRoute('/_app/locations/')({
  validateSearch: createSearchValidator<LocationFilters, string>({
    tabs: [],
    filterKeys: ['countryCodes'],
    sortKeys: LOCATION_SORT_KEYS
  }),
  staticData: {
    breadCrumb: 'Locations'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});